import {
  RouterModule,
  Routes,
  withComponentInputBinding,
} from '@angular/router';
import { AuthGuard } from '../core/auth.guard';
import { SupervisorAuthGuard } from '../core/supervisor-auth.guard';
import { NgModule } from '@angular/core';

import { SupervisorMainComponent } from './supervisor-main.component';
import { ProgramsComponent } from './programs/programs.component';
import { PlaylistsComponent } from './playlists/playlists.component';
import { TargetsComponent } from './targets/targets.component';
import { SkillAreasComponent } from './skill-areas/skill-areas.component';
import { RemindersComponent } from './reminders/reminders.component';
import { BehaviorsComponent } from './behaviors/behaviors.component';
import { PromptCodesPatientComponent } from './prompt-codes/prompt-codes-patient.component';
import { PromptSchedulesPatientComponent } from './prompt-schedules/prompt-schedules-patient.component';
import { MaintananceCriteriaPatientComponent } from './maintanance-criteria/maintanance-criteria-patient.component';
import { MasteryCriteriaComponent } from '../settings/mastery-criteria/mastery-criteria.component';
import { ProbeCriteriaComponent } from '../settings/probe-criteria/probe-criteria.component';
import { AntecedentsComponent } from './abc/antecendents/antecedents.component';
import { ConsequencesComponent } from './abc/consequences/consequences.component';
import { ImportDataComponent } from './import-data/import-data.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { NotesComponent } from './notes/notes.component';
import { OverviewComponent } from './overview/overview.component';
import { MergeTargetsComponent } from './merge-targets/merge-targets.component';
import { MergeBehaviorsComponent } from './merge-behaviors/merge-behaviors.component';
import { MoveSessionDataComponent } from './move-session-data/move-session-data.component';
import { BipBehaviorsComponent } from './bip/bip-behaviors/bip-behaviors.component';
import { BipCrisisCycleComponent } from './bip/bip-crisis-cycle/bip-crisis-cycle.component';
import { BipEmergencyProceduresComponent } from './bip/bip-emergency-procedures/bip-emergency-procedures.component';
import { BipAdditionalInfoComponent } from './bip/bip-additional-info/bip-additional-info.component';
import { BipListComponent } from './bip/bip-list/bip-list.component';
import { BipQuickReferenceComponent } from './bip/bip-quick-reference/bip-quick-reference.component';
import { StaffManagementReportComponent } from './management-report/staff-management-report.component';

const routes: Routes = [
  {
    path: 'supervisor',
    redirectTo: 'supervisor/:patientID',
    pathMatch: 'full',
  },

  {
    path: 'supervisor/:patientID',
    redirectTo: 'supervisor/:patientID/overview',
    pathMatch: 'full',
  },
  {
    path: 'supervisor/:patientID',
    component: SupervisorMainComponent,
    canActivate: [SupervisorAuthGuard],
    children: [
      {
        path: 'programs',
        component: ProgramsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'playlists',
        component: PlaylistsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'targets',
        component: TargetsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'reminders',
        component: RemindersComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'behaviors',
        component: BehaviorsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'skillAreas',
        component: SkillAreasComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'prompt-codes',
        component: PromptCodesPatientComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'prompt-schedules',
        component: PromptSchedulesPatientComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'maintanance-criteria',
        component: MaintananceCriteriaPatientComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'mastery-criteria',
        component: MasteryCriteriaComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'probe-criteria',
        component: ProbeCriteriaComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'antecedents',
        component: AntecedentsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'consequences',
        component: ConsequencesComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'import-data',
        component: ImportDataComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'instructions',
        component: InstructionsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'notes',
        component: NotesComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'overview',
        component: OverviewComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'management-report',
        component: StaffManagementReportComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'merge-targets',
        component: MergeTargetsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'merge-behaviors',
        component: MergeBehaviorsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'move-session-data',
        component: MoveSessionDataComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/QuickReference',
        component: BipQuickReferenceComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/Behaviors',
        component: BipBehaviorsComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/List',
        component: BipListComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/CrisisCycle',
        component: BipCrisisCycleComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/EmergencyProcedures',
        component: BipEmergencyProceduresComponent,
        canActivate: [SupervisorAuthGuard],
      },
      {
        path: 'BIP/AdditionalInfo',
        component: BipAdditionalInfoComponent,
        canActivate: [SupervisorAuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class SupervisorRoutingModule {}
